"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function stripHash(fragment) {
  return fragment.replace(/^#*/, "");
}

// just the necessary bits of Backbone router+history

var Router = function () {
  function Router(app) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Router);

    // allow injecting window dep
    this.window = options.window || window;

    this.app = app;
    var routeDefs = this.app.getConfig("routes");

    // https://github.com/jashkenas/backbone/blob/d682061a/backbone.js#L1476-L1479
    // Cached regular expressions for matching named param parts and splatted
    // parts of route strings.
    var optionalParam = /\((.*?)\)/g;
    var namedParam = /(\(\?)?:\w+/g;
    var splatParam = /\*\w+/g;
    var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g; // eslint-disable-line no-useless-escape
    this.compiledRoutes = Object.keys(routeDefs).map(function (routeExpr) {
      // https://github.com/jashkenas/backbone/blob/d682061a/backbone.js#L1537-L1547
      var expr = routeExpr.replace(escapeRegExp, "\\$&").replace(optionalParam, "(?:$1)?").replace(namedParam, function (match, optional) {
        return optional ? match : "([^/?]+)";
      }).replace(splatParam, "([^?]*?)");
      expr = new RegExp("^" + expr + "(?:\\?([\\s\\S]*))?$");

      // hook up route handler function
      var handler = routeDefs[routeExpr];
      if (typeof handler === "string") {
        // reference to another handler rather than its own function
        handler = routeDefs[handler];
      }

      return { expr: expr, handler: handler };
    });

    this.registerListeners(options.historyMethod || "pushState");
  }

  _createClass(Router, [{
    key: "registerListeners",
    value: function registerListeners(historyMethod) {
      var _this = this;

      this.navigateToHash = function () {
        return _this.navigate(_this.window.location.hash);
      };
      this.window.addEventListener("popstate", this.navigateToHash);

      this.historyMethod = historyMethod;
      this.origChangeStateMethod = this.window.history[this.historyMethod];
      this.window.history[this.historyMethod] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this.origChangeStateMethod.apply(_this.window.history, args);
        _this.navigateToHash();
      };
    }
  }, {
    key: "unregisterListeners",
    value: function unregisterListeners() {
      this.window.removeEventListener("popstate", this.navigateToHash);
      this.window.history[this.historyMethod] = this.origChangeStateMethod;
    }
  }, {
    key: "navigate",
    value: function navigate(fragment) {
      var _this2 = this;

      var stateUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      fragment = stripHash(fragment);
      if (fragment === this.app.state.$fragment && !Object.keys(stateUpdate).length) {
        return;
      }

      stateUpdate.$fragment = fragment;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.compiledRoutes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var route = _step.value;

          var matches = route.expr.exec(fragment);
          if (matches) {
            var _ret = function () {
              // extract params
              // https://github.com/jashkenas/backbone/blob/d682061a/backbone.js#L1553-L1558
              var params = matches.slice(1);
              params = params.map(function (param, i) {
                // Don't decode the search params.
                if (i === params.length - 1) {
                  return param || null;
                }
                return param ? decodeURIComponent(param) : null;
              });

              var routeHandler = route.handler;
              if (!routeHandler) {
                throw "No route handler defined for #" + fragment;
              }
              var routeStateUpdate = routeHandler.call.apply(routeHandler, [_this2.app, stateUpdate].concat(_toConsumableArray(params)));
              if (routeStateUpdate) {
                // don't update if route handler returned a falsey result
                _this2.app.update(Object.assign({}, stateUpdate, routeStateUpdate));
              }
              return {
                v: void 0
              };
            }();

            if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
          }
        }

        // no route matched
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      console.error("No route found matching #" + fragment);
    }
  }, {
    key: "replaceHash",
    value: function replaceHash(fragment) {
      fragment = stripHash(fragment);
      if (fragment !== stripHash(this.window.location.hash)) {
        this.window.history[this.historyMethod](null, null, "#" + fragment);
      }
    }
  }]);

  return Router;
}();

exports.default = Router;


//////////////////
// WEBPACK FOOTER
// ../node_modules/panel/build/router.js
// module id = 187
// module chunks = 0 1 2 3 4 8 9 10 11 12 20 21 22 23 24 25 26 27 28 34 38 39